import {
  faFaceSmileHearts,
  faLock,
  faMessageSmile,
  faMicrophone,
  faRectangleHistory,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Button,
  ChildUser,
  FlexBox,
  JoonColorExpanded,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useEffect } from "react"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"

import squelcheeOn from "/images/avatars/squelchee_on.png"
import squelcheeOff from "/images/avatars/squelchee_off.png"

import {
  DoterAIInfoStep,
  useDoterAIInfoModalStore,
} from "./useDoterAIInfoModalStore"
import ParentTestimonialCarousel from "../../../../components/carousel/ParentTestimonialCarousel"
import { useSetUpChildFTUXModal } from "../../../../components/modals/SetUpChildFTUXModal"
import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"
import { PREFERENCE_KEY } from "../../../../constants"
import { useUpdatePreferenceMutation } from "../../../../networking/families/mutations"
import { useFamilyQuery } from "../../../../networking/queries"
import { FamilyQuerySelect } from "../../../../types"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../../util/analytics"

const DoterAIInfoModal = () => {
  const { isOpen, onClose, currentStep, isOnboarding } =
    useDoterAIInfoModalStore()

  const renderStep = () => {
    switch (currentStep) {
      case DoterAIInfoStep.STEP_1:
        return <DoterAIInfoStep1 />
      case DoterAIInfoStep.STEP_2:
        return <DoterAIInfoStep2 />
      case DoterAIInfoStep.STEP_3:
        return <DoterAIInfoStep3 />
      default:
        return null
    }
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      desktopWidth="400px"
      mandatory={isOnboarding}
    >
      {renderStep()}
    </SlideUpModal>
  )
}

export const DoterAIInfoStep1 = ({
  isEmptyState = false,
}: {
  isEmptyState?: boolean
}) => {
  const { setCurrentStep, isOnboarding } = useDoterAIInfoModalStore()
  const { t } = useTranslation()

  const handleNext = () => {
    setCurrentStep(DoterAIInfoStep.STEP_2)
  }

  return (
    <>
      <div className="flex flex-col h-full overflow-auto">
        {isOnboarding ? (
          <div className="flex flex-col gap-2 p-6 pb-4">
            <Typography variant="h3" textAlign="center">
              {t("DOTER_AI_STEP1_TITLE")}
            </Typography>
            <Typography variant="bodySmall" textAlign="center">
              {t("DOTER_AI_TRUSTED")}
            </Typography>
          </div>
        ) : (
          <div className="flex flex-col p-6">
            <Typography
              variant="bodyXSmall"
              style={{
                borderRadius: SPACING.space1,
                background: JoonColorExpanded.yellow300,
                padding: `${SPACING.space1} ${SPACING.space2}`,
                fontWeight: 600,
                marginBottom: SPACING.space2,
                width: "fit-content",
              }}
            >
              {t("DOTER_AI_NEW_FROM_JOON")}
            </Typography>
            <Typography variant="h3" textAlign="left">
              {t("DOTER_AI_33_MORE")}
            </Typography>
          </div>
        )}
        <FlexBox
          direction="column"
          style={{
            padding: SPACING.space4,
            background:
              "linear-gradient(291deg, rgba(152, 242, 219, 0.40) 10.3%, rgba(36, 155, 238, 0.40) 91.68%), #FFF",
          }}
          gap={SPACING.space2}
        >
          <FlexBox
            direction="row"
            wrap={false}
            align="flex-end"
            gap={SPACING.space4}
          >
            <img
              src={"/images/avatars/aiDoter.svg"}
              alt="doter"
              style={{ height: "40px" }}
            />
            <FlexBox direction="column">
              <Typography variant="bodySmall" style={{ fontWeight: 600 }}>
                Doter: Sharky
              </Typography>
              <Typography
                variant="bodySmall"
                style={{
                  background: "rgba(249, 250, 252, 0.60)",
                  padding: SPACING.space2,
                  borderRadius: SPACING.space2,
                  width: "80%",
                }}
              >
                {t("DOTER_AI_DEMO_MSG1")}
              </Typography>
            </FlexBox>
          </FlexBox>
          <FlexBox
            direction="row"
            wrap={false}
            align="flex-end"
            gap={SPACING.space4}
          >
            <FlexBox direction="column" align="flex-end">
              <Typography variant="bodySmall">Kevin</Typography>
              <Typography
                variant="bodySmall"
                style={{
                  background: JoonColorExpanded.purple600,
                  padding: SPACING.space2,
                  width: "80%",
                  borderRadius: SPACING.space2,
                }}
              >
                <Typography
                  variant="bodySmall"
                  color={JoonUIColor.text.inverted}
                >
                  {t("DOTER_AI_DEMO_MSG2")}
                </Typography>
              </Typography>
            </FlexBox>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                width: SPACING.space8,
                minWidth: SPACING.space8,
                height: SPACING.space8,
                minHeight: SPACING.space8,
                background: JoonColorExpanded.purple600,
              }}
            >
              <Typography
                variant="body"
                color={JoonUIColor.background.primaryNeutral}
              >
                K
              </Typography>
            </div>
          </FlexBox>
          <FlexBox
            direction="row"
            wrap={false}
            align="flex-end"
            gap={SPACING.space4}
          >
            <img
              src={"/images/avatars/aiDoter.svg"}
              style={{ height: "40px" }}
              alt="doterai"
            />
            <FlexBox direction="column">
              <Typography variant="bodySmall" style={{ fontWeight: 600 }}>
                Doter: Sharky
              </Typography>
              <Typography
                variant="bodySmall"
                style={{
                  background: "rgba(249, 250, 252, 0.60)",
                  padding: SPACING.space2,
                  width: "80%",
                  borderRadius: SPACING.space2,
                }}
              >
                {t("DOTER_AI_DEMO_MSG3")}
              </Typography>
            </FlexBox>
          </FlexBox>
        </FlexBox>
        <FlexBox
          direction="column"
          gap={SPACING.space4}
          style={{
            padding: SPACING.space6,
            paddingTop: SPACING.space4,
          }}
        >
          {isOnboarding ? (
            <Typography variant="h3">{t("DOTER_AI_33_MORE")}</Typography>
          ) : (
            <Typography variant="h3">{t("DOTER_AI_TAP_INTO")}</Typography>
          )}
          <FlexBox direction="row" wrap={false} gap={SPACING.space2}>
            <div className="flex w-[24px] justify-center">
              <FontAwesomeIcon
                icon={faFaceSmileHearts}
                fontSize={18}
                style={{ marginTop: SPACING.space1 }}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="bodySmallBold">
                {t("DOTER_AI_LESS_NAGGING_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                <Trans
                  i18nKey="DOTER_AI_LESS_NAGGING_DESC"
                  components={{
                    b: <Typography variant="bodySmallBold">{""}</Typography>,
                  }}
                />
              </Typography>
            </FlexBox>
          </FlexBox>
          <FlexBox direction="row" wrap={false} gap={SPACING.space2}>
            <div className="flex w-[24px] justify-center">
              <FontAwesomeIcon
                icon={faMessageSmile}
                fontSize={18}
                style={{ marginTop: SPACING.space1 }}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="bodySmallBold">
                {t("DOTER_AI_SAFETY_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("DOTER_AI_SAFETY_DESC")}
              </Typography>
            </FlexBox>
          </FlexBox>
          <FlexBox direction="row" wrap={false} gap={SPACING.space2}>
            <div className="flex w-[24px] justify-center">
              <FontAwesomeIcon
                icon={faMicrophone}
                fontSize={18}
                style={{ marginTop: SPACING.space05 }}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="bodySmallBold">
                {t("DOTER_AI_VOICE_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("DOTER_AI_VOICE_DESC")}
              </Typography>
            </FlexBox>
          </FlexBox>
        </FlexBox>
      </div>
      {!isEmptyState && (
        <div className="px-6 pb-4 pt-2 bg-white w-full border-t border-borderPrimary">
          <Button
            text={t("FTUX_NEXT")}
            fullWidth
            onClick={handleNext}
            style={{ borderRadius: SPACING.space2 }}
          />
        </div>
      )}
    </>
  )
}

const DoterAIInfoStep2 = () => {
  const { setCurrentStep, onClose, isOnboarding } = useDoterAIInfoModalStore()
  const { t } = useTranslation()

  const handleNext = () => {
    if (isOnboarding) {
      setCurrentStep(DoterAIInfoStep.STEP_3)
    } else {
      onClose()
    }
  }

  return (
    <>
      <div className="flex flex-col h-full overflow-auto">
        <FlexBox
          direction="column"
          style={{
            padding: SPACING.space6,
            paddingBottom: SPACING.space4,
          }}
        >
          <Typography variant="h3" textAlign="left">
            {t("DOTER_AI_TRUSTED")}
          </Typography>
        </FlexBox>
        <div
          className="w-full"
          style={{
            padding: SPACING.space4,
            background:
              "linear-gradient(291deg, rgba(152, 242, 219, 0.40) 10.3%, rgba(36, 155, 238, 0.40) 91.68%), #FFF",
          }}
        >
          <ParentTestimonialCarousel />
        </div>
        <FlexBox
          direction="column"
          gap={SPACING.space4}
          style={{
            padding: SPACING.space6,
            paddingTop: SPACING.space4,
          }}
        >
          <Typography variant="h3">{t("DOTER_AI_INSIGHTS_TITLE")}</Typography>
          <FlexBox direction="row" wrap={false} gap={SPACING.space2}>
            <FontAwesomeIcon
              icon={faRectangleHistory}
              fontSize={16}
              style={{ marginTop: SPACING.space05 }}
              color={JoonUIColor.icon.accent}
            />
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="bodySmallBold">
                {t("DOTER_AI_HISTORY_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("DOTER_AI_HISTORY_DESC")}
              </Typography>
            </FlexBox>
          </FlexBox>
          <FlexBox direction="row" wrap={false} gap={SPACING.space2}>
            <FontAwesomeIcon
              icon={faLock}
              fontSize={18}
              style={{ marginTop: SPACING.space05 }}
              color={JoonUIColor.icon.accent}
            />
            <FlexBox direction="column" gap={SPACING.space1}>
              <Typography variant="bodySmallBold">
                {t("DOTER_AI_CONTROL_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("DOTER_AI_CONTROL_DESC")}
              </Typography>
            </FlexBox>
          </FlexBox>
        </FlexBox>
      </div>
      <div className="px-6 pb-4 pt-2 bg-white w-full border-t border-borderPrimary">
        <Button
          text={
            isOnboarding ? t("DOTER_AI_SETUP_CONVERSATIONS") : t("FTUX_DONE")
          }
          fullWidth
          style={{ borderRadius: SPACING.space2 }}
          onClick={handleNext}
        />
      </div>
    </>
  )
}

const DoterAIInfoStep3 = () => {
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const { onClose, isOnboarding } = useDoterAIInfoModalStore()
  const { onOpen: onOpenSetUpChildFTUXModal } = useSetUpChildFTUXModal()
  const { t } = useTranslation()
  const [pendingToggleStates, setPendingToggleStates] = useState<{
    [key: number]: boolean
  }>({})
  const updatePreferenceMutation = useUpdatePreferenceMutation()

  const handleSave = async () => {
    onClose()
    const promises: Promise<any>[] = []
    Object.keys(pendingToggleStates).forEach((childId) => {
      const isEnabled = pendingToggleStates[parseInt(childId)]
      promises.push(
        updatePreferenceMutation.mutateAsync({
          childId: parseInt(childId),
          key: PREFERENCE_KEY.enableDoterChat,
          value: pendingToggleStates[parseInt(childId)],
        })
      )
      trackAnalyticEvent(ANALYTIC_EVENTS.TOGGLE_DOTER_CHAT, {
        source: "ftux",
        enabled: isEnabled,
      })
    })
    await Promise.all(promises)
    if (isOnboarding) {
      onOpenSetUpChildFTUXModal()
    }
  }

  const handleToggle = (child: ChildUser, isSelected: boolean) => {
    setPendingToggleStates({
      ...pendingToggleStates,
      [child.id]: isSelected,
    })
  }

  // Set default toggle states
  useEffect(() => {
    if (!children) return
    const newToggleStates = { ...pendingToggleStates }
    children.forEach((child) => {
      newToggleStates[child.user.id] = true
    })
    setPendingToggleStates(newToggleStates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children])

  return (
    <>
      <div className="flex flex-col h-full overflow-auto">
        <div className="flex flex-col p-6 pb-0">
          <Typography variant="h3" textAlign="left">
            {t("DOTER_AI_WHICH_CHILD")}
          </Typography>
        </div>
        <div className="p-6 pb-4 pt-4 w-full">
          {children?.map((child) => (
            <div className="flex flex-col gap-2 p2 rounded-md border border-borderPrimary w-full p-3">
              <Typography variant="bodyBold">{child.user.name}</Typography>
              <div className="flex flex-row gap-2">
                <SquelcheeOffButton
                  onClick={() => handleToggle(child.user, false)}
                  isSelected={!pendingToggleStates[child.user.id]}
                />
                <SquelcheeOnButton
                  onClick={() => handleToggle(child.user, true)}
                  isSelected={pendingToggleStates[child.user.id]}
                />
              </div>
            </div>
          ))}
        </div>
        <Typography
          variant="bodyXSmall"
          textAlign="center"
          className="mx-auto py-2 max-w-[300px]"
        >
          {t("DOTER_AI_CHANGE_SETTING")}
        </Typography>
      </div>
      <div className="px-6 pb-4 pt-2 bg-white w-full border-t border-borderPrimary">
        <Button
          text={t("DOTER_AI_SAVE_SETTINGS")}
          fullWidth
          style={{ borderRadius: SPACING.space2 }}
          onClick={handleSave}
        />
      </div>
    </>
  )
}

export default DoterAIInfoModal

const SquelcheeOffButton = ({
  onClick,
  isSelected,
}: {
  onClick: () => void
  isSelected: boolean
}) => {
  const { t } = useTranslation()
  return (
    <button onClick={onClick} className="flex-1">
      <div
        className={`flex flex-row gap-2 items-center border rounded-md justify-center ${
          isSelected ? "border-primary" : "border-transparent bg-bgLightGray"
        }`}
      >
        <Typography
          variant="bodyBold"
          color={
            isSelected
              ? JoonUIColor.text.primaryAccent
              : JoonUIColor.text.primary
          }
        >
          {t("DOTER_AI_OFF")}
        </Typography>
        <img
          src={squelcheeOff}
          alt="doter AI off"
          style={isSelected ? {} : { filter: "grayscale(100%)" }}
          className="h-[54px] -translate-y-[-1px]"
        />
      </div>
    </button>
  )
}

const SquelcheeOnButton = ({
  onClick,
  isSelected,
}: {
  onClick: () => void
  isSelected: boolean
}) => {
  const { t } = useTranslation()
  return (
    <button onClick={onClick} className="flex-1">
      <div
        className={`flex flex-row gap-2 items-center border rounded-md justify-center ${
          isSelected ? "border-primary" : "border-transparent bg-bgLightGray"
        }`}
      >
        <img
          src={squelcheeOn}
          alt="doter AI on"
          style={isSelected ? {} : { filter: "grayscale(100%)" }}
          className="h-[54px] -translate-y-[-1px]"
        />
        <Typography
          variant="bodyBold"
          color={
            isSelected
              ? JoonUIColor.text.primaryAccent
              : JoonUIColor.text.primary
          }
        >
          {t("DOTER_AI_ON")}
        </Typography>
      </div>
    </button>
  )
}
